import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const QuantifyingUncertainty = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Quantifying Uncertainty"
    videos={[
      "https://www.youtube.com/embed/MIf5shIfsj8"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default QuantifyingUncertainty;
